exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**  rel=\"stylesheet/scss\" lang=\"scss\"*/\n/** backgroud */\n/** border */\n/** table */\n/* Popover\n-------------------------- */\n/* Dialog\n-------------------------- */\n[data-v-93caf034]:export {\n  xrColorPrimary: #2362FB;\n}\n.cursor-pointer[data-v-93caf034] {\n  cursor: pointer;\n}\n.el-avatar[data-v-93caf034] img {\n  width: 100%;\n  background: white !important;\n}\n", ""]);

// exports
